import { Menu, MenuItem, Typography } from "@mui/material";
import React from "react";
import { useBreakpoint } from "@avenue-8/sidekick-ui";
import { Link } from "react-router-dom";
import { RoleAuthorized } from "@shared/components/RoleAuthorized";
import { UserRoles } from "../../store/auth.store";
import { useDevTools } from "@features/DevTools/useDevTools";
import { UserAvatar } from "@features/Chat/components/UserAvatar";

type Props = {
  onLogout: () => void;
  onSettingsClick: () => void;
  userName?: string;
  userAvatar: string;
  userEmail?: string;
  userRoles: Array<string>;
};

const getFirstName = (name: string) => {
  const firstName = name.split(" ")[0];
  return firstName;
};

export const NavbarMenu = (props: Props) => {
  const {
    onLogout,
    onSettingsClick,
    userName,
    userEmail,
    userRoles,
    userAvatar,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isMobile = useBreakpoint("mobile");
  const { isDevToolsEnabled, handleToggleDevTools } = useDevTools();

  const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getHandleClick = (handler: () => void) => () => {
    handler();
    handleClose();
  };

  return (
    <div>
      <div
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        role="button"
        onClick={handleClickMenu}
      >
        <UserAvatar
          userName={userName || userEmail || ""}
          userAvatar={userAvatar}
        />
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        autoFocus={false}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {isMobile && (
          <MenuItem disabled>
            <Typography
              variant="body1"
              textTransform={userName ? "capitalize" : "lowercase"}
            >
              {userName ? getFirstName(userName) : userEmail}
            </Typography>
          </MenuItem>
        )}
        <RoleAuthorized
          userRoles={userRoles}
          authorizedRoles={[UserRoles.Admin]}
          authorizedComponent={
            <MenuItem component={Link} to={"/admin"}>
              Admin
            </MenuItem>
          }
        />
        <MenuItem component={Link} to={"/account"}>
          Account
        </MenuItem>
        <MenuItem onClick={getHandleClick(onSettingsClick)}>Settings</MenuItem>
        {isDevToolsEnabled && (
          <MenuItem onClick={getHandleClick(() => handleToggleDevTools(true))}>
            DevTools
          </MenuItem>
        )}
        <MenuItem onClick={getHandleClick(onLogout)}>Sign Out</MenuItem>
      </Menu>
    </div>
  );
};
